/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-console */
import faroLog, { faroSetUser } from 'modules/common/utils/faro';
/**
 * Entire application logger function
 */
class Logger {
  constructor() {
    this.prep = (messages) => [`phg-log::`, ...messages];
    this.setUserImpl = faroSetUser;
    this.logEventImpl = ({ name, level = 'info', context = {} }) => {
      const msg = name;
      faroLog(msg, level.toUpperCase(), context);
    };
  }

  /**
   * Sets the current user context for the underlying logging implementation.
   *
   * @param {{ username?: string }} user
   */
  setUser = (user) => {
    this.setUserImpl(user);
  };

  /**
   * Structured logging entry point.
   * Keeps vendor choice (e.g. Faro) centralized in this module.
   *
   * @param {Object} params
   * @param {string} params.name - Event name (e.g. 'pbi_rendered').
   * @param {string} [params.level='info'] - Log level.
   * @param {Object} [params.context={}] - Additional context fields.
   */
  logEvent = ({ name, level = 'info', context = {} }) => {
    this.logEventImpl({ name, level, context });
  };

  error = (...error) => {
    console.error(...this.prep(error));
  };

  info = (...message) => {
    console.info(...this.prep(message));
  };

  warn = (...message) => {
    console.warn(...this.prep(message));
  };

  log = (...message) => {
    console.log(...this.prep(message));
  };
}
//
export default new Logger();
